export default "__VITE_ASSET__D99fkkmi__"